import { useEffect, useState } from 'react';
import { QuestionSetClient } from '../services/apiClient'; 
import { API_BASE_URL } from '../config/config';
import axiosInstance from "../services/axiosInstance";

const useQuestionSets = () => {
    const [questionSets, setQuestionSets] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const client = new QuestionSetClient(API_BASE_URL, axiosInstance);

    useEffect(() => {
        const fetchQuestionSets = async () => {
            setIsLoading(true);
            try {
                const sets = await client.getQuestionSets();
                if (sets && sets.success && sets.data) {
                    setQuestionSets(sets.data);
                } else {
                    setError('Failed to fetch question sets');
                }
            } catch (err) {
                setError('Error fetching question sets');
                console.error('Error fetching question sets:', err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchQuestionSets();
    }, []);

    return { questionSets, isLoading, error };
};

export default useQuestionSets;
